export const COOKIE_NAME_USE_NATIVE_ONLINE_TICKETING = 'use-native-online-ticketing';
export const SEARCH_PARAM_NAME_NATIVE_ONLINE_TICKETING = 'not';
